import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";

const Pagination = ({ currentPage, onChangePage, maxPage }) => {
  return (
    <div className="flex justify-center mt-8">
      <div className="flex gap-3 items-center">
        {currentPage > 1 && (
          <Link
            to={onChangePage(currentPage - 1)}
            className="transition duration-300 hover:text-white"
          >
            <MdArrowBackIos size={25} />
          </Link>
        )}

        {currentPage < 5 ? (
          <>
            {new Array(maxPage < 5 ? maxPage : 5).fill("").map((_, index) => (
              <Link
                key={index}
                to={onChangePage(index + 1)}
                className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                  currentPage === index + 1 && "!bg-white text-dark-darken"
                }`}
              >
                {index + 1}
              </Link>
            ))}
            {maxPage > 5 && (
              <>
                {maxPage > 6 && <span>...</span>}
                <Link
                  to={onChangePage(maxPage)}
                  className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                    currentPage === maxPage && "!bg-white text-dark-darken"
                  }`}
                >
                  {maxPage}
                </Link>
              </>
            )}
          </>
        ) : currentPage > maxPage - 4 ? (
          <>
            <Link
              to={onChangePage(1)}
              className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                currentPage === 1 && "!bg-white text-dark-darken"
              }`}
            >
              1
            </Link>
            <span>...</span>
            {[...new Array(5)].map((_, index) => (
              <Link
                key={index}
                to={onChangePage(maxPage - 4 + index)}
                className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                  currentPage === maxPage - 4 + index &&
                  "!bg-white text-dark-darken"
                }`}
              >
                {maxPage - 4 + index}
              </Link>
            ))}
          </>
        ) : (
          <>
            <Link
              to={onChangePage(1)}
              className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                currentPage === 1 && "!bg-white text-dark-darken"
              }`}
            >
              1
            </Link>
            <span>...</span>
            {new Array(5).fill("").map((_, index) => (
              <Link
                key={index}
                to={onChangePage(currentPage - 2 + index)}
                className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                  currentPage === currentPage - 2 + index &&
                  "!bg-white text-dark-darken"
                }`}
              >
                {currentPage - 2 + index}
              </Link>
            ))}
            <span>...</span>
            <Link
              to={onChangePage(maxPage)}
              className={`flex justify-center items-center inline-block h-10 w-10 bg-dark-lighten rounded-full hover:bg-dark-lighten-2 hover:text-white transition duration-300 ${
                currentPage === maxPage && "!bg-white text-dark-darken"
              }`}
            >
              {maxPage}
            </Link>
          </>
        )}

        {currentPage < maxPage && (
          <Link
            to={onChangePage(currentPage + 1)}
            className="transition duration-300 hover:text-white"
          >
            <MdArrowForwardIos size={25} />
          </Link>
        )}
      </div>
    </div>
  );
};

export default Pagination;
